import axios from 'axios';
import apiService from '@/core/common/services/api.service';
import { getReisetermin } from '@/core/common/services/odata.service';
import { odataErrorHandler } from '@/core/common/services/error-handler.service';

// In dieser Funktion werden die Restriktionen für einen Zeitraum und die gewählten Filter geladen
// laender und reisen werden jeweils als wiederholte Query-Parameter (?land=DE&land=FR) übergeben
// von und bis sind Pflichtparameter im Format YYYY-MM-DD
export async function getRestriktionskonfiguration({ von, bis, laender = [], reisen = [], signal }) {
  const params = new URLSearchParams();
  params.set('von', von);
  params.set('bis', bis);
  laender.forEach(code => params.append('land', code));
  reisen.forEach(kuerzel => params.append('reise', kuerzel));

  return apiService
    .get('Restriktionskonfiguration', `?${params.toString()}`, { signal })
    .then(res => (res.data && res.data.result ? res.data.result : null))
    .catch(error => {
      // Abgebrochene Requests (AbortController) sind gewollt und lösen keine Fehleranzeige aus
      if (axios.isCancel(error)) {
        return null;
      }
      return odataErrorHandler(error);
    });
}

// Reisetermine, deren Abreisedatum im übergebenen Zeitraum liegt werden hier geladen
// reisen enthält die Reisekürzel, von und bis sind Datumsangaben im Format YYYY-MM-DD
export async function getReisetermineImZeitraum({ von, bis, reisen = [] }) {
  // Ohne Reise oder ohne vollständigen Zeitraum gibt es nichts zu prüfen, der Request entfällt
  if (!reisen.length || !von || !bis) {
    return [];
  }
  // abreisedatum ist ein Zeitstempel, ohne Tagesende würden Termine am letzten Tag herausfallen
  const bisEndeDesTages = new Date(bis);
  bisEndeDesTages.setHours(23, 59, 59);

  const response = await getReisetermin({
    // Gelöschte und verworfene Termine bleiben außen vor, sie sind für den Hinweis nicht relevant
    filter: {
      'reise/reisekuerzel': { in: reisen },
      abreisedatum: { ge: new Date(von), le: bisEndeDesTages },
      isDeleted: false,
      state: { ne: 'Verworfen' },
    },
    select: ['id', 'reiseterminkuerzel', 'abreisedatum'],
    orderBy: ['abreisedatum'],
  });

  return (response && response.data) || [];
}

// In dieser Funktion wird eine Restriktionskonfiguration (Sperrzeit) gespeichert
// Ein gesetztes payload.id kennzeichnet eine bestehende Konfiguration und führt zu einem PUT, sonst POST
export async function saveRestriktionskonfiguration(payload) {
  const request = payload.id
    ? apiService.put('Restriktionskonfiguration', payload)
    : apiService.post('Restriktionskonfiguration', payload);

  return request
    .then(res => res.data)
    .catch(error => {
      odataErrorHandler(error);
      return Promise.reject(error);
    });
}

// In dieser Funktion wird eine einzelne Restriktion an einem bestimmten Tag gelöscht
export async function deleteRestriktionTag({ id, datum }) {
  return apiService
    .delete(`/Restriktionskonfiguration/${id}/restriktion/${datum}`)
    .then(res => res.data)
    .catch(odataErrorHandler);
}

// In dieser Funktion wird eine komplette Serie (Restriktionskonfiguration) gelöscht
export async function deleteRestriktionSerie({ id }) {
  return apiService
    .delete(`/Restriktionskonfiguration/${id}`)
    .then(res => res.data)
    .catch(odataErrorHandler);
}
